export function SkipLink() {
  return (
    <a
      href="#main"
      className="sr-only z-[70] rounded-md bg-brand-500 px-4 py-2 font-semibold text-white focus:not-sr-only focus:fixed focus:left-4 focus:top-4"
    >
      Skip to content
    </a>
  )
}
